import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';
import {
    IRefund,
    ISrvdep,
    IResponseGetRefundList,
} from '../interfaces/refund.interfaces';
import { CookieConsentService } from './cookie-consent/cookie-consent-service';

@Injectable({ providedIn: 'root' })
export class RefundService {
    public constructor(
        public http: HttpNewService,
        public auth: AuthService,
        private cookieService: CookieConsentService,
    ) {}

    public fetchRefundReasons(): Promise<Array<IResponseGetRefundList>> {
        return lastValueFrom(
            this.http.get<Array<IResponseGetRefundList>>('/refund/list'),
        );
    }

    public sendRefund(refund: IRefund): Promise<void> {
        const data = {
            paymentId: refund.paymentId,
            reasonId: refund.reasonId,
            note: refund.note,
            refundType: refund.refundType,
            lastCardNum: refund.lastCardNum,
            payDat: refund.payDate,
            bankName: refund.bankName,
            inn: refund.inn,
            bik: refund.bik,
            corrBill: refund.corrBill,
            accBill: refund.accBill,
            srvdepIds: refund.srvdepIds,
            customerId: this.cookieService.getParentCookieData(),
        };

        return lastValueFrom(this.http.post<void>('/refund/save', data));
    }

    /** Получение списка услуг */
    public fetchServices(paymentId: number): Promise<IResponseGetRefundList[]> {
        return lastValueFrom(
            this.http.get<Array<IResponseGetRefundList>>(
                '/refund/services?pPaymentId=' + paymentId,
            ),
        );
    }
}
export { ISrvdep, IRefund };
